import "core-js";
import smoothscroll from "smoothscroll-polyfill";
import "intersection-observer";
import "resize-observer-polyfill";

if (!("scrollBehavior" in document.documentElement.style)) {
  smoothscroll.polyfill();
}
